import dayjs from 'dayjs';

export const isTimeframeOverlappingPeriod = (
  startTime: Date | string,
  durationMinutes: number,
  fromDateTime: Date | string,
  toDateTime: Date | string,
): boolean => {
  const dStartTime = dayjs(startTime);
  const dTo = dayjs(toDateTime);
  if (dStartTime.isAfter(dTo)) return false;

  const dEndTime = dStartTime.add(durationMinutes, 'minutes');
  const dFrom = dayjs(fromDateTime);
  if (dEndTime.isBefore(dFrom)) return false;

  return true;
};
